export const recipeBookPanelClassName =
	'rounded-2xl border border-gray-200 border-opacity-80 dark:border-dark-border bg-white bg-opacity-90 dark:bg-dark-card shadow-sm backdrop-blur-sm';

export const recipeBookSelectClassName =
	'w-full rounded-xl border border-gray-200 dark:border-dark-border bg-gray-50 bg-opacity-50 dark:bg-dark-bg px-3 py-2 text-sm text-gray-800 dark:text-dark-text focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition';

export const recipeBookFilterLabelClassName =
	'mb-1.5 text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-gray-400';

export const recipeBookFilterFieldClassName = 'flex flex-col flex-1 min-w-0 sm:min-w-32';

// Treat tier uses yellow-* (tailwind.config maps yellow → amber palette; amber-* classes are not generated)
export function tierBadgeClassName(variant) {
	if (variant === 'indulgent') {
		return 'text-yellow-900 bg-yellow-100 ring-yellow-200 dark:text-yellow-900 dark:bg-yellow-300 dark:ring-yellow-600';
	}
	if (variant === 'balanced') {
		return 'text-blue-900 bg-blue-100 ring-blue-200 dark:text-blue-900 dark:bg-blue-400 dark:ring-blue-500';
	}
	return 'text-green-900 bg-green-100 ring-green-200 dark:text-green-900 dark:bg-green-400 dark:ring-green-500';
}

/** Tier / health pills — text-xs (0.75rem) */
export const recipeBookTierBadgeBaseClassName =
	'inline-block rounded px-1.5 py-0.5 text-xs font-medium uppercase tracking-wide leading-none ring-1';

export const recipeBookHealthBadgeClassName =
	'inline-block rounded px-1.5 py-0.5 text-xs font-medium uppercase tracking-wide leading-none text-green-900 bg-green-100 ring-1 ring-green-200 dark:text-green-900 dark:bg-green-400 dark:ring-green-500';

/** Prev / next and pagination controls */
export const recipeBookNavButtonClassName =
	'px-3 py-1.5 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 ring-1 ring-gray-200 transition-colors hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed dark:border-dark-border dark:bg-dark-bg dark:text-dark-text dark:ring-dark-border dark:hover:bg-gray-700';

/** Challenge Wire direction badges — same compact pill system as recipe tier tags. */
export function challengeBadgeClassName(variant) {
	const colors = {
		sent: tierBadgeClassName('balanced'),
		forYou: tierBadgeClassName('indulgent'),
		from: 'text-gray-700 bg-gray-100 ring-gray-200 dark:text-gray-200 dark:bg-gray-700 dark:ring-gray-600',
		to: tierBadgeClassName('health'),
		household: 'text-indigo-900 bg-indigo-100 ring-indigo-200 dark:text-indigo-100 dark:bg-indigo-900 dark:ring-indigo-600',
		muted: 'text-gray-600 bg-gray-50 ring-gray-200 dark:text-gray-300 dark:bg-dark-bg dark:ring-dark-border'
	};

	return `${recipeBookTierBadgeBaseClassName} ${colors[variant] || colors.muted}`;
}
